module.exports = __webpack_public_path__ + "static/inspec-a5413071a4e506daf194043e8f5da140.png";